module.exports = __webpack_public_path__ + "img/logo-local.bede68cc.jpg";